<template>
  <div class="case-detail-data-list-region-overlapping-gene-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="main-data-container row-block flex-start">
      <div class="data-info-field row-block flex-start" :style="{ width: '250px' }">
        <div class="data-info-container col-block flex-start">
          <div class="data-info-block col-block flex-start">
            <div class="gene-name-container row-block">
              <div class="gene-name" :style="{ 'max-width': '230px' }">{{ geneData.gene_name || '- -' }}</div>
              <div :style="{ width: '15px' }"></div>
              <borCor
                :disabled="onDragging"
                :arrow="false"
                :background="'white'"
                :border="'#CCCCCC'"
                :radius="'0px'"
                :blockStyle="{ padding: '10px' }"
              >
                <div slot="trigger">
                  <div class="img-block">
                    <img :src="require('../../assets/images/large-external-link-arrow-icon.svg')" alt="">
                  </div>
                </div>
                <div class="content col-block flex-start" slot="content">
                  <template v-if="Object.keys(getMainLinks(geneData)).length">
                    <div class="link-container col-block flex-start">
                      <div class="link row-block" v-for="(link, title, lindex) in getMainLinks(geneData)" :key="lindex" @click="e => link.func()">
                        <div class="link-title">{{ title }}</div>
                        <div :style="{ width: '5px' }"></div>
                        <img :src="link.icon" alt="">
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '5px' }">
                  </template>
                  <div class="link-container col-block flex-start">
                    <div class="link row-block" v-for="(link, title, lindex) in getExternalLinks('gene', geneData)" :key="lindex" @click="e => openExternalLinks(link)">
                      <div class="link-title">{{ title }}</div>
                      <div :style="{ width: '5px' }"></div>
                      <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                </div>
              </borCor>
            </div>
          </div>
          <div class="data-option-container row-block">
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="data-tag-container row-block flex-wrap" :style="{ 'max-width': ((Math.max(1400, windowWidth) - 160) / 4) + 'px' }">
            <div class="data-tag-block" v-for="(tag, mindex) in [].filter(tag => displayTabs.includes(tag.type || type))" :key="mindex" @click="e => (tag.func || (() => {}))()">
              <div class="data-tag" :title="tag.title" :class="{ clickable: tag.func }" :style="caseDataTagOptions[tag.type || type]">{{ tag.title }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="data-table-field col-block width-full" :style="{ flex: 1 }">
        <div class="data-table-container row-block flex-start" :style="{ flex: 1 }">
          <div :style="{ flex: 1 }"></div>
          <div class="data-table-block block-table">
            <div class="data-table-row row-block stretch">
              <div :style="{ flex: 1 }"></div>
              <div
                class="data-table-col col-block width-full"
                v-for="(option, oindex) in dataTableOption.filter(option => (option.display || (() => true))(geneData))"
                :key="oindex"
                :class="[
                  option.position,
                  { link: option.link }
                ]"
                :style="{
                  width: option.width,
                  'max-width': option.maxWidth
                }"
                @mouseover="e => tableOnHover(option, true)"
                @mouseleave="e => tableOnHover(option, false)"
                @click="e => openTableLink(geneData, option.link)"
              >
                <div class="data-table-cell-block row-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="data-table-cell shrink row-block">
                    <div
                      class="data-table-content"
                      v-html="option.title"
                    ></div>
                    <borCor
                      v-if="option.desc"
                      :disabled="onDragging"
                      :width="'200px'"
                      :background="'white'"
                      :border="'#CCCCCC'"
                      :radius="'5px'"
                      :blockStyle="{ padding: '10px' }"
                    >
                      <div slot="trigger">
                        <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                      </div>
                      <div slot="content">
                        <div>{{ option.desc }}</div>
                      </div>
                    </borCor>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
            <div class="data-table-row row-block stretch">
              <div :style="{ flex: 1 }"></div>
              <div
                class="data-table-col col-block width-full"
                v-for="(option, oindex) in dataTableOption.filter(option => (option.display || (() => true))(geneData))"
                :key="oindex"
                :class="[
                  option.position,
                  { link: option.link }
                ]"
                :style="{
                  width: option.width,
                  'max-width': option.maxWidth
                }"
                @mouseover="e => tableOnHover(option, true)"
                @mouseleave="e => tableOnHover(option, false)"
                @click="e => openTableLink(geneData, option.link)"
              >
                <div class="data-table-cell-block row-block" :style="{ flex: 1 }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="data-table-cell shrink row-block">
                    <template v-if="option.value === 'option'">
                      <div class="data-table-option-container col-block">
                        <div :style="{ flex: 1 }"></div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="data-table-content shrink"
                        :style="option.color ? { color: option.color(geneData) } : {}"
                        v-html="dataTableValueMap(option, localeMap(option.value(geneData)))"
                      ></div>
                      <borCor
                        v-if="option.links"
                        :disabled="onDragging"
                        :arrow="false"
                        :background="'white'"
                        :border="'#CCCCCC'"
                        :radius="'0px'"
                        :blockStyle="{ padding: '10px' }"
                      >
                        <div slot="trigger">
                          <div class="img-block">
                            <img :src="require('../../assets/images/external-link-arrow-icon.svg')" alt="">
                          </div>
                        </div>
                        <div class="content col-block" slot="content">
                          <div class="link-container col-block flex-start">
                            <a class="link row-block" :href="link.url(geneData)" target="_blank" v-for="(link, lindex) in option.links" :key="lindex">
                              <div class="link-title">{{ link.title }}</div>
                              <div :style="{ width: '5px' }"></div>
                              <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                              <div :style="{ flex: 1 }"></div>
                            </a>
                          </div>
                        </div>
                      </borCor>
                    </template>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="data-table-border" :class="{ display: tableHover[option.title] }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="geneData.phenotypeDatas.length > 0" class="condition-disease-container row-block flex-start">
      <!-- <div class="condition-container col-block flex-start" :style="{ flex: 1, 'max-width': Math.min(724, (Math.max(1400, windowWidth) - 186) / 2) + 'px' }"> -->
      <div class="condition-container col-block flex-start" :style="{ flex: 1 }">
        <div class="condition-title">{{ $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___title') }}</div>
        <div class="row-block flex-start" :style="{ gap: '10px', width: '100%' }">
          <div class="condition-block col-block width-full" :style="{ flex: 1, width: 0 }">
            <div class="condition-phenotype-container col-block width-full">
              <div
                class="condition-phenotype-block row-block"
                v-for="(phenotype, index) in limit['phenotype'].active ? geneData.phenotypeDatas.slice(0, limit['phenotype'].value) : geneData.phenotypeDatas"
                :key="index"
                :class="{ selected: false, selectable: false }"
                @click="e => e.currentTarget.className.split(' ').includes('selectable') && switchPhenotype(geneData, phenotype)"
              >
                <div v-if="phenotypeAlertDisplay(phenotype)" class="condition-phenotype-alert center-block">
                  <borCor
                    :disabled="onDragging"
                    :width="'300px'"
                    :background="'white'"
                    :border="'#CCCCCC'"
                    :radius="'0px'"
                    :blockStyle="{ padding: '10px' }"
                  >
                    <div slot="trigger">
                      <img :src="require('../../assets/images/if-alert-icon.svg')" alt="" :style="{ width: '16px' }">
                    </div>
                    <div class="content col-block" slot="content">
                      <div>{{ $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___alert01') }}</div>
                    </div>
                  </borCor>
                  <div :style="{ width: '5px' }"></div>
                </div>
                <div
                  class="condition-phenotype-title shrink"
                  :title="{ 'true': phenotype.Phenotype, 'false': phenotype.disease }[!(geneData.SYMBOL || '').startsWith('MT-') + '']"
                  v-html="{ 'true': phenotype.Phenotype, 'false': phenotype.disease }[!(geneData.SYMBOL || '').startsWith('MT-') + '']"
                ></div>
                <div :style="{ width: '4px' }"></div>
                <div class="condition-inheritance-container">
                  <div class="condition-inheritance-block row-block">
                    <div class="condition-inheritance-title row-block">
                      <div v-if="({ 'true': phenotype.Inheritance, 'false': phenotype.inheritance }[!(geneData.SYMBOL || '').startsWith('MT-') + ''] || []).length" class="hr">|</div>
                      <div class="inheritance" :class="[inheritance]" v-for="(inheritance, iindex) in { 'true': phenotype.Inheritance, 'false': phenotype.inheritance }[!(geneData.SYMBOL || '').startsWith('MT-') + ''] || []" :key="iindex">
                        <span>{{ iindex ? ', ' : '' }}<span class="text">{{ inheritance }}</span></span>
                      </div>
                    </div>
                    <div :style="{ width: '5px' }"></div>
                    <div class="condition-inheritance-img-container">
                      <borCor
                        :disabled="onDragging"
                        :arrow="false"
                        :type="dataList[dataIndex + 1] ? 'bottom' : 'top'"
                        :background="'white'"
                        :border="'#CCCCCC'"
                        :radius="'0px'"
                        :blockStyle="{ padding: '10px' }"
                      >
                        <div slot="trigger">
                          <div class="condition-inheritance-img-block">
                            <img :src="require('../../assets/images/external-link-arrow-icon.svg')" alt="">
                          </div>
                        </div>
                        <div class="content col-block" slot="content">
                          <div class="link-container col-block flex-start">
                            <div class="link row-block" v-for="(link, title, lindex) in getExternalLinks({ 'true': 'phenotype', 'false': 'orphaPhenotype' }[!(geneData.SYMBOL || '').startsWith('MT-') + ''], phenotype)" :key="lindex" @click="e => openExternalLinks(link)">
                              <div class="link-title">{{ title }}</div>
                              <div :style="{ width: '5px' }"></div>
                              <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </div>
                        </div>
                      </borCor>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div
                v-if="geneData.phenotypeDatas.length - limit['phenotype'].value > 0"
                class="condition-phenotype-more"
                @click="e => limit['phenotype'].active = !limit['phenotype'].active"
              >{{ !limit['phenotype'].active ? '(' + $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___less') + ')' : '(' + $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___more', { count: geneData.phenotypeDatas.length - limit['phenotype'].value }) + ')' }}</div>
            </div>
          </div>
          <div class="condition-option-container col-block flex-start">
          </div>
        </div>
      </div>
      <div v-if="diseaseDisplay(geneData)" class="disease-container col-block flex-start" :style="{ flex: 1, 'max-width': Math.min(872, (Math.max(1400, windowWidth) - 186) / 2) + 'px' }">
        <template v-if="diseaseDisplay(geneData)">
          <div class="disease-title">{{ $t('COMPONENT.caseDetail.regionOverlappingGeneData.disease.___title') }}</div>
          <div class="disease-block col-block width-full">
            <div class="hpo-container col-block stretch">
              <div class="hpo-block row-block" :class="[hpo.result]" v-for="([hpoID, hpo], index) in geneData.phenotypeData.hpo_network ? (limit['network'].active ? Object.entries(geneData.phenotypeData.hpo_network).slice(0, limit['network'].value) : Object.entries(geneData.phenotypeData.hpo_network)) : [{}]" :key="index">
                <template v-if="hpo.name">
                  <div class="hpo-link-title ellipsis" :title="hpo.path ? [...hpo.path].reverse()[0].name : ''" :style="{ width: '240px' }">{{ hpo.path ? [...hpo.path].reverse()[0].name : '' }}</div>
                  <div :style="{ width: '5px' }"></div>
                  <a v-if="hpo.path" class="hpo-link" :href="'https://hpo.jax.org/app/browse/term/' + [...hpo.path].reverse()[0].id" target="_blank">
                    <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                  </a>
                  <div v-else :style="{ opacity: 0 }">
                    <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                  </div>
                  <div :style="{ width: '10px' }"></div>
                  <div class="hpo-icon">
                    <diseaseIcon
                      :disabled="onDragging"
                      :paths="hpo.path || (hpo.result === 'no_hit' ? null : [])"
                      :borCorType="dataList[dataIndex + 1] ? 'bottom' : 'top'"
                    ></diseaseIcon>
                  </div>
                  <div :style="{ width: '10px' }"></div>
                  <div class="hpo-title ellipsis shrink" :title="hpo.name">{{ hpo.name }}</div>
                  <div :style="{ width: '5px' }"></div>
                  <a class="hpo-link" :href="'https://hpo.jax.org/app/browse/term/' + hpoID" target="_blank">
                    <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                  </a>
                  <div :style="{ flex: 1 }"></div>
                </template>
                <div v-else class="hpo-title" :style="{ flex: 1 }">- -</div>
              </div>
              <div
                v-if="Object.entries(geneData.phenotypeData.hpo_network || {}).length - limit['network'].value > 0"
                class="condition-hpo-more"
                @click="e => limit['network'].active = !limit['network'].active"
              >{{ !limit['network'].active ? '(' + $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___less') + ')' : '(' + $t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___more', { count: Object.entries(geneData.phenotypeData.hpo_network || {}).length - limit['network'].value }) + ')' }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import caseErrorMessage from '../case/errorMessage.vue'
import diseaseIcon from '../case/diseaseIcon.vue'
import borCor from '../tool/newBorCor.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import responsitive from '../../mixins/responsitive.vue'
import {
  caseDataTagOptions,
  omimPhenotypeIDList,
  defaultEmptyDisplay,
  svDosageSensitivityOptions
} from '../../constants/global/data'

export default {
  components: {
    caseErrorMessage,
    diseaseIcon,
    borCor
  },
  mixins: [
    routeLoading,
    responsitive
  ],
  props: {
    onDragging: {
      type: Boolean,
      default: () => false
    },
    // mainData
    dataList: {
      type: Array,
      required: true
    },
    dataIndex: {
      type: Number,
      required: true
    },
    geneData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectingPhenotype: null,
      tableHover: {},
      limit: {
        'phenotype': {
          value: 5,
          active: true
        },
        'network': {
          value: 5,
          active: true
        }
      }
    }
  },
  computed: {
    // static
    dataTableOption () {
      const svDosageSensitivityMap = svDosageSensitivityOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
      return [
        {
          title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___Overlap_region'),
          value: geneData => [
            geneData.location2 ? ('<b>' + geneData.location2 + '</b>') : '',
            geneData.location
          ].filter(x => x).join('<br>'),
          color: null,
          width: '18%',
          maxWidth: '175px',
          position: 'center',
          noKey: this.$t(defaultEmptyDisplay.noKey),
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___Dosage_sensitivity'),
          value: geneData => {
            let haplo = [
              '<b>' + this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.Dosage_sensitivity.___Haplo') + ':</b> ',
              svDosageSensitivityMap[geneData.HI] ? this.$t(svDosageSensitivityMap[geneData.HI].title) : '- -'
            ].join('')
            let triplo = [
              '<b>' + this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.Dosage_sensitivity.___Triplo') + ':</b> ',
              svDosageSensitivityMap[geneData.TS] ? this.$t(svDosageSensitivityMap[geneData.TS].title) : '- -'
            ].join('')
            return [
              '<span' + ((svDosageSensitivityMap[geneData.HI] || {}).alert ? ' style=color:#FA3D3D' : '') + '>' + haplo + '</span>',
              '<span' + ((svDosageSensitivityMap[geneData.TS] || {}).alert ? ' style=color:#FA3D3D' : '') + '>' + triplo + '</span>'
            ].join('<br>')
          },
          color: null,
          width: '45%',
          maxWidth: '410px',
          position: 'center',
          noKey: this.$t(defaultEmptyDisplay.noKey),
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___pLI'),
          value: geneData => {
            let genomAD = [
              '<b>' + this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.pLI.___GenomAD') + ':</b> ',
              ![undefined, null].includes(geneData.GnomAD_pLI) ? geneData.GnomAD_pLI : '- -'
            ].join('')
            let ExAC = [
              '<b>' + this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.pLI.___ExAC') + ':</b> ',
              ![undefined, null].includes(geneData.ExAC_pLI) ? geneData.ExAC_pLI : '- -'
            ].join('')
            return [
              '<span' + (geneData.GnomAD_pLI > 0.9 ? ' style=color:#FA3D3D' : '') + '>' + genomAD + '</span>',
              '<span' + (geneData.ExAC_pLI > 0.9 ? ' style=color:#FA3D3D' : '') + '>' + ExAC + '</span>'
            ].join('<br>')
          },
          color: null,
          width: '22%',
          maxWidth: '210px',
          position: 'center',
          noKey: this.$t(defaultEmptyDisplay.noKey),
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___LOEUF'),
          value: geneData => ![undefined, null].includes(geneData.LOEUF) ? ('<span' + (geneData.LOEUF < 0.35 ? ' style=color:#FA3D3D' : '') + '>' + geneData.LOEUF + '</span>') : geneData.LOEUF,
          color: null,
          width: '10%',
          maxWidth: '70px',
          position: 'center',
          noKey: this.$t(defaultEmptyDisplay.noKey),
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ]
    },
    // global
    caseDataTagOptions () { return caseDataTagOptions }
  },
  methods: {
    ...mapActions([
      'setModal2Action',
      'setLoadingAction'
    ]),
    // External Link
    getMainLinks (data) {
      return {}
    },
    getExternalLinks (type, data, subData = {}) {
      if (type === 'gene') {
        let geneData = {
          ...data,
          ...subData
        }
        let externalLinks = [
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR'), ['https://medlineplus.gov/genetics/gene/' + (geneData.gene_name || '').toLowerCase()]],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___NCBI_Gene'), ['https://www.ncbi.nlm.nih.gov/gene/' + (geneData.gene_id || '')]],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM'), ['https://www.omim.org/entry/' + (geneData.Gene_MIM_Number || '')]],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___UniProt'), (geneData.UniProtKB_AC || '').split('|').filter(x => x).map(uniProt => 'https://www.uniprot.org/uniprot/' + uniProt)]
        ]
        return {
          ...externalLinks.filter(kv => (kv[1] || []).length).reduce((result, kv) => ({ ...result, [kv[0]]: kv[1] }), {}),
          ...geneData.external_links
        }
      } else if (type === 'phenotype') {
        let phenotype = {
          ...data,
          ...subData
        }
        return {
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR')]: ['https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?&v:project=medlineplus&v:sources=medlineplus-bundle&query=' + (phenotype.Phenotype || '') + '&binning-state=group%3d%3dGenetics%0aalpha%3d%3dGenetic%20Conditions&'],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___HPO')]: ['https://hpo.jax.org/app/browse/disease/OMIM:' + (phenotype.id || '')],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM')]: ['https://www.omim.org/entry/' + (phenotype.id || '')],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___Orphanet')]: [phenotype.Orpha_id ? ('https://www.orpha.net/en/disease/detail/' + phenotype.Orpha_id) : 'https://www.orpha.net/en/disease'],
          ...phenotype.external_links
        }
      } else if (type === 'orphaPhenotype') {
        let orphaPhenotype = {
          ...data,
          ...subData
        }
        return {
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR')]: ['https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?&v:project=medlineplus&v:sources=medlineplus-bundle&query=' + (orphaPhenotype.disease || '') + '&binning-state=group%3d%3dGenetics%0aalpha%3d%3dGenetic%20Conditions&'],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___HPO')]: ['https://hpo.jax.org/app/browse/disease/ORPHA:' + (orphaPhenotype.id || '')],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM')]: ['https://www.omim.org/search?index=entry&search=orphanet_id:' + (orphaPhenotype.id || '')],
          [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___Orphanet')]: ['https://www.orpha.net/en/disease/detail/' + (orphaPhenotype.id || '')],
          ...orphaPhenotype.external_links
        }
      }
    },
    openExternalLinks (links) {
      links = links instanceof Array ? links : [links]
      links.forEach(link => window.open(link))
    },
    // phenotype
    phenotypeAlertDisplay (phenotype) {
      return false && omimPhenotypeIDList.includes(phenotype.id)
    },
    diseaseDisplay (geneData) {
      return false
    },
    async switchPhenotype (geneData, phenotype) {
      // this.selectingPhenotype = phenotype
    },
    // table
    dataTableValueMap (option, value) {
      let result = value || value === 0 ? value : value === null ? (option.empty || this.$t(defaultEmptyDisplay.empty)) : (option.noKey || this.$t(defaultEmptyDisplay.noKey))
      return option.limit ? (result.slice(0, option.limit) + (result.length > option.limit ? '...' : '')) : result
    },
    localeMap (value) {
      return value && (value + '').startsWith('CONSTANT.global.data') ? this.$t(value) : value
    },
    tableOnHover (option, value) {
      this.tableHover = {
        ...this.tableHover,
        [option.title]: value
      }
    },
    async openTableLink (geneData, link) {
      switch (link) {
        default: {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/regionOverlappingGeneData.vue